import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface feedbackState {
  data: [] | null | any;
  totalRecords: number | null;
}

const initialState: feedbackState = {
  data: null,
  totalRecords: null,
};

export const feedbackSlice = createSlice({
  name: 'feedbacks',
  initialState,
  reducers: {
    setFeedback: (state, action) => {
      state.data = action.payload;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewFeedback: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFeedback, addNewFeedback, reset } = feedbackSlice.actions;

// selectors
export const getfeedbackSpaces = (state: any) => state.accounts.data;
export const getfeedbackTotalRecord = (state: RootState) => state.feedbacks.totalRecords;

export default feedbackSlice.reducer;
